import type { InputHTMLAttributes } from 'react';

type CheckboxProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  label: string;
};

export function Checkbox({ label, id, className = '', checked, ...rest }: CheckboxProps) {
  const inputId = id ?? label.toLowerCase().replace(/\s+/g, '-');

  return (
    <label htmlFor={inputId} className={`flex cursor-pointer items-center gap-3 ${className}`}>
      <span className="relative">
        <input
          id={inputId}
          type="checkbox"
          checked={checked}
          className="peer sr-only"
          {...rest}
        />
        <span
          className={`flex size-5 items-center justify-center rounded-sm border border-border-strong bg-bg-surface text-[13px] font-bold text-text-inverse peer-checked:border-action-primary peer-checked:bg-action-primary ${checked ? 'border-action-primary bg-action-primary' : ''}`}
        >
          {checked && '✓'}
        </span>
      </span>
      <span className="text-[13px] font-medium text-text-primary">{label}</span>
    </label>
  );
}
